export default {
      id: "ic_info_warning_white-usage",
      viewBox: "0 0 12 12",
      url: "/" + "images/icons.3.109.2.svg#ic_info_warning_white-usage",
      toString: function () {
        return this.url;
      }
    }